import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useTheme } from '../context/ThemeContext';

function RichTextEditor({ value, onChange, placeholder }) {
  const { darkMode } = useTheme();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean']
    ]
  };

  return (
    <div style={{ marginBottom: '14px' }}>
      <style>{`
        .ql-container { 
          border-radius: 0 0 10px 10px !important;
          background: ${darkMode ? '#0f0f1a' : '#fff'} !important;
          color: ${darkMode ? '#e0e0e0' : '#333'} !important;
          font-family: 'Segoe UI', sans-serif !important;
          font-size: 14px !important;
          min-height: 200px !important;
          border-color: ${darkMode ? 'rgba(255,255,255,0.1)' : '#e0e0e0'} !important;
        }
        .ql-toolbar {
          border-radius: 10px 10px 0 0 !important;
          background: ${darkMode ? '#1a1a2e' : '#f5f5f5'} !important;
          border-color: ${darkMode ? 'rgba(255,255,255,0.1)' : '#e0e0e0'} !important;
        }
        .ql-toolbar .ql-stroke { stroke: ${darkMode ? '#ccc' : '#444'} !important; }
        .ql-toolbar .ql-fill { fill: ${darkMode ? '#ccc' : '#444'} !important; }
        .ql-toolbar .ql-picker { color: ${darkMode ? '#ccc' : '#444'} !important; }
        .ql-toolbar button:hover .ql-stroke { stroke: #e94560 !important; }
        .ql-toolbar button.ql-active .ql-stroke { stroke: #e94560 !important; }
        .ql-editor.ql-blank::before { color: ${darkMode ? '#555' : '#aaa'} !important; font-style: normal !important; }
        .ql-editor { min-height: 200px !important; }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder || 'Write detailed event information here...'}
      />
    </div>
  );
}

export default RichTextEditor;